const Zhihu = () => import('views/zhihu/Zhihu')
const ZhihuIndex = () => import('views/zhihu/ZhihuIndex')
const ZhihuPage = () => import('views/zhihu/ZhihuPage')
const CommentPage = () => import('views/zhihu/CommentPage')

export default {
  path: '/zhihu',
  name: 'Zhihu',
  component: Zhihu,
  meta: { needAuth: true },
  children: [
    {
      path: '',
      name: 'ZhihuIndex',
      component: ZhihuIndex,
      meta: { needAuth: false }
    },
    {
      path: '/zhihu/question/:questionId',
      name: 'ZhihuPage',
      component: ZhihuPage,
      meta: { needAuth: false }
    },
    {
      path: '/zhihu/comment',
      name: 'CommentPage',
      component: CommentPage,
      meta: { needAuth: false }
    }
  ]
}
